/* eslint-disable */
import fileService from '@/shared/file/file-service';
import logService from '@/shared/entity-logger';
import { db, firebase } from '@/shared/firebase/firebase-init';
import _ from 'underscore'
import moment from 'moment'
import Cookies from 'js-cookie' // birthdate
import clubModel from '@/entities/club/club-model';
import tournamentModel from './tournament-model';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';

//  import tournamentModel from './tournament-model';
const NAME_ENTITY= 'tournament'
const KEY_TOURNAMETS = 'tournaments'
const KEY_CLUBS = 'clubs'

export default {
  list() {
    return new Promise((resolve) => {
      // eslint-disable-next-line
      db.ref(KEY_TOURNAMETS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_TOURNAMETS).child(id).once('value').then((snapshot) => { 
        const model = snapshot.val();
        
        if (!model) {
          return null;
        }
        resolve(model)
      })
    });
  },

  /**
   * Elimina un equipo, solo en el caso de que el club no tenga jugadores
   * @param {*} model 
   * @param {*} loggedUser 
   */
  destroy(model, loggedUser) {
    const modelToDestroy = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      deleted:  firebase.database.ServerValue.TIMESTAMP,
      deletedBy:  { id: loggedUser.id, email: loggedUser.email },
      modifiedBy:  { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {

         // 1. Comprobamos si el club tiene equipos 
      if (_.size(model.players) > 0) {
        reject(new Error("El equipo tiene jugadores asignados."))
      } else {
        var updates = {};
        updates['/' + KEY_TOURNAMETS + '/' + model.id ] = null;

        db.ref().update(updates, (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            logService.log(modelToDestroy, "deleted", KEY_TOURNAMETS, NAME_ENTITY)
            resolve()
          }
        })
      }
    })
  },

  update(model, loggedUser) {
    return new Promise((resolve, reject) => {

      const modelToUpdate = {
        ...model,
        modified:  firebase.database.ServerValue.TIMESTAMP,
        modifiedBy: { id: loggedUser.id, email: loggedUser.email }
      };

      var updates = {};
      updates['/' + KEY_CLUBS + '/' + modelToUpdate.club.id + '/' + KEY_TOURNAMETS + '/'+ modelToUpdate.id] = tournamentModel.forClub(modelToUpdate);;


      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          // Logs
          logService.log(modelToUpdate, "modified", KEY_TOURNAMETS, NAME_ENTITY)
          resolve()
        }
      })
    });
  },

  create(model, loggedUser) {
    
    console.log("<------ CREATE TOURNAMENT")
    const modelToSave = {
      ...model,
      id: db.ref(KEY_TOURNAMETS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email } ,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      var updates = {};
      updates['/' + KEY_TOURNAMETS + '/' + modelToSave.id ] = modelToSave;

      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          logService.log(modelToSave, "created", KEY_TOURNAMETS, NAME_ENTITY)
          resolve()
        }
      });
    });
  },

  exportAsPDF (tournament) {
    return new Promise((resolve, reject) => {
      console.log(tournament);

      /**
       * PLAYERS PARSING
       */

      var playerDataList = []
      var playerHeaderList = [
        [ 'Nombre deportivo', 'Nombre','Apellidos', 'Dni', 'Fecha de nacim.','Dorsal']
      ]
      
      // Players
      _.each(tournament.players, (player, key, list) => {
        var birthdate =  moment( player.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [player.namePublic, player.name, player.lastName, player.dni, birthdate, player.dorsal ]
        playerDataList.push(values)
      })
     
      /**
       * COACHES PARSING
       */

      var coachDataList = []
      var coachHeaderList = [
        [ 'Nombre','Apellidos', 'Dni']
      ]
      
      // Coaches
      _.each(tournament.coaches, (coach, key, list) => {
        // var birthdate =  moment( coach.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [coach.name,coach.lastName,coach.dni]
        coachDataList.push(values)
      })
     
      /**
       * TOURNAMENT MANAGERS PARSING
       */

      var tournamentManagerDataList = []
      var tournamentManagerHeaderList = [
        [ 'Nombre','Apellidos', 'Dni']
      ]
      
      // Managers
      _.each(tournament.tournamentManagers, (tm, key, list) => {
        // var birthdate =  moment( tm.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [ tm.name, tm.lastName, tm.dni]
        tournamentManagerDataList.push(values)
      })
     
      /*************************************************************
       *                                                           *
       *                CREAACION DEL DOC PDF                      *
       *                                                           *
       *************************************************************/

      var doc = new jsPDF()
      var docName = tournament.name + '_' + tournament.category.label + '.pdf'
      var docTitle = "Datos del equipo"
      
      doc.setFontSize(22);
      doc.text(docTitle, 14, 20);
      doc.setFontSize(12);

      var img = new Image();
      img.addEventListener('load', function() {
         // doc.addImage(img, 'png', 10, 50);
      });
      img.src = '/static/logos/logo_dv7.png';
      doc.addImage(img, 'JPEG', 175, 12 , 20, 45);

      // Team data
      //  Labels
      doc.text("Nombre:", 14, 35);
      doc.text("Categoría:", 14, 40);
      doc.text("Club:", 14, 45);

      doc.text(tournament.name, 40, 35);
      doc.text(tournament.category.label, 40, 40);
      doc.text(tournament.club.name, 40, 45);

      // Team information

      // Coaches
      doc.setFontSize(14);
      doc.text("Entrenadores", 14,  60);
      doc.autoTable({ head: coachHeaderList, body: coachDataList,   startY: 65,  theme: 'plain', styles: {cellPadding: 0.5, fontSize: 10, halign: 'center' } });
      let finalYCoach = doc.previousAutoTable.finalY;
      
      // Team Managers
      doc.setFontSize(14);
      doc.text("Delegados", 14, finalYCoach + 15);
      doc.autoTable({head: tournamentManagerHeaderList, body: tournamentManagerDataList, startY: finalYCoach + 20,  styles: {cellPadding: 0.5, fontSize: 10, halign: 'center'} });
      let finalYTeamManager = doc.previousAutoTable.finalY;
      
      // Players
      doc.setFontSize(14);
      doc.text("Jugadores", 14, finalYTeamManager + 15);
      doc.autoTable({head: playerHeaderList, body: playerDataList,  startY: finalYTeamManager + 20,  styles: {cellPadding: 0.5, fontSize: 10,  halign: 'center'} });

      doc.save(docName);
      resolve()
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_TOURNAMETS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          const modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.name = childSnapshot.val().name,
          modelOption.label = childSnapshot.val().name + ' · ' + childSnapshot.val().category.label
          modelOption.club = childSnapshot.val().club
          modelOption.category = childSnapshot.val().category
          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/tournament/tournament-service.js